import { tokenStorage } from './tokenStore';

/** @public Knip ignore, used in generated files */
export const getAccessToken = () => {
	const accessToken = tokenStorage.accessToken.get();

	return accessToken?.token;
};
